import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getUnitById = async (id: number) => {
  const url = endpoints.UNIT + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createUnit = async (params: any) => {
  const url = endpoints.UNIT;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateUnit = async (params: any) => {
  const url = endpoints.UNIT + "/" + params.id;

  const { data: response } = await axios.patch(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteUnit = async (id: number) => {
  const url = endpoints.UNIT + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const services = {
  createUnit,
  updateUnit,
  deleteUnit,
  getUnitById,
};

export default services;
